import { useCallback, useRef, useState } from "react";

import CustomModal from "@components/CustomModal";
import GiveUserAccessToSubscription from "@components/Modals/GiveUserAccessToSubscription";

import ExportMembersModal from "../ExportMembers";

import useMembersList from "./hooks/useMembersList";
import MembersListView from "./view";

export default function MembersListModal({ modalRef }) {
  const [open, setOpen] = useState(false);
  const [communityId, setCommunityId] = useState(null);
  const callbackRef = useRef(null);
  const giveAccessRef = useRef(null);
  const exportRef = useRef(null);

  modalRef.current = {
    open(id, callback) {
      setCommunityId(id);
      callbackRef.current = callback || null;
      setOpen(true);
    },
    close() {
      setOpen(false);
    },
  };

  const state = useMembersList({ communityId, open });

  const handleClose = () => {
    setOpen(false);
    if (callbackRef.current) callbackRef.current();
  };

  const handleActivateSubscription = useCallback(
    (member) => {
      if (!member?.user_id || !communityId || !giveAccessRef.current) return;
      giveAccessRef.current.open(
        { id: member.user_id, username: member.username, nickname: member.nickname },
        communityId,
        state.refresh
      );
    },
    [communityId, state.refresh]
  );

  const handleExport = useCallback(() => {
    if (!communityId || !exportRef.current) return;
    exportRef.current.open(communityId, {
      search: state.search,
      filters: state.filters,
    });
  }, [communityId, state.search, state.filters]);

  return (
    <>
      <MembersListView
        {...state}
        open={open}
        communityId={communityId}
        onClose={handleClose}
        ModalComponent={CustomModal}
        onActivateSubscription={handleActivateSubscription}
        onChangeRole={state.changeRole}
        onRemoveMember={state.removeMember}
        onExport={handleExport}
      />
      <GiveUserAccessToSubscription modalRef={giveAccessRef} />
      <ExportMembersModal modalRef={exportRef} />
    </>
  );
}
